export const ChecklistIcon = (props) => (
  <svg fill="none" height={16} viewBox="0 0 24 24" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 6.5l2 2 3.5-3.5M3 14.5l2 2 3.5-3.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
    <path d="M12 6h9M12 15h9" stroke="currentColor" strokeLinecap="round" strokeWidth={2} />
  </svg>
);
